import { FullDeck } from '../../app/api/karte';
export function WinRateSvi(data, brojIgraca) {
	var simulations = 3000;
	var playersData = [
		[data[0], data[0 + brojIgraca]],
		[data[1], data[1 + brojIgraca]],
		[data[2], data[2 + brojIgraca]],
		[data[3], data[3 + brojIgraca]],
		[data[4], data[4 + brojIgraca]],
		[data[5], data[5 + brojIgraca]],
		[data[6], data[6 + brojIgraca]],
		[data[7], data[7 + brojIgraca]],
	];

	if (brojIgraca === 9) {
		playersData.push([data[8], data[8 + brojIgraca]]);
	}

	var players = playersData;
	const numPlayers = players.length;
	const allCards = players.flat();
	const rankMap = {
		2: 0,
		3: 1,
		4: 2,
		5: 3,
		6: 4,
		7: 5,
		8: 6,
		9: 7,
		T: 8,
		J: 9,
		Q: 10,
		K: 11,
		A: 12,
	};

	const fullDeck = FullDeck;

	const wins = new Array(numPlayers).fill(0);
	let draws = 0;
	const evalCache = new Map();

	function evaluate(hand) {
		const counts = {};
		const suitsCount = {};
		const values = [];

		for (const card of hand) {
			const r = card[0],
				s = card[1];
			const v = rankMap[r];
			counts[v] = (counts[v] || 0) + 1;
			suitsCount[s] = (suitsCount[s] || 0) + 1;
			values.push(v);
		}

		values.sort((a, b) => b - a);
		const uniqueVals = [...new Set(values)].sort((a, b) => b - a);

		let isFlush = false,
			flushSuit = null;
		for (const s in suitsCount) {
			if (suitsCount[s] >= 5) {
				isFlush = true;
				flushSuit = s;
				break;
			}
		}

		let isStraight = false,
			topStraightValue = -1;
		for (let i = 0; i <= uniqueVals.length - 5; i++) {
			if (uniqueVals[i] - uniqueVals[i + 4] === 4) {
				isStraight = true;
				topStraightValue = uniqueVals[i];
				break;
			}
		}
		if (!isStraight && [12, 0, 1, 2, 3].every(v => uniqueVals.includes(v))) {
			isStraight = true;
			topStraightValue = 3;
		}

		let isStraightFlush = false,
			topStraightFlushValue = -1;
		if (flushSuit) {
			const flushVals = hand.filter(c => c[1] === flushSuit).map(c => rankMap[c[0]]);
			const flushUnique = [...new Set(flushVals)].sort((a, b) => b - a);
			for (let i = 0; i <= flushUnique.length - 5; i++) {
				if (flushUnique[i] - flushUnique[i + 4] === 4) {
					isStraightFlush = true;
					topStraightFlushValue = flushUnique[i];
					break;
				}
			}
			if (!isStraightFlush && [12, 0, 1, 2, 3].every(v => flushUnique.includes(v))) {
				isStraightFlush = true;
				topStraightFlushValue = 3;
			}
		}

		const groups = Object.entries(counts)
			.map(([k, v]) => [parseInt(k), v])
			.sort((a, b) => b[1] - a[1] || b[0] - a[0]);
		const [first, second = [-1, 0]] = groups;

		if (isStraightFlush) return [9, topStraightFlushValue];
		if (first[1] === 4) return [8, first[0], ...uniqueVals.filter(v => v !== first[0])];
		if (first[1] === 3 && second[1] >= 2) return [7, first[0], second[0]];
		if (isFlush) {
			const flushCards = hand
				.filter(c => c[1] === flushSuit)
				.map(c => rankMap[c[0]])
				.sort((a, b) => b - a);
			return [6, ...flushCards.slice(0, 5)];
		}
		if (isStraight) return [5, topStraightValue];
		if (first[1] === 3) return [4, first[0], ...uniqueVals.filter(v => v !== first[0]).slice(0, 2)];
		if (first[1] === 2 && second[1] === 2) {
			const pairs = [first[0], second[0]].sort((a, b) => b - a);
			const kicker = uniqueVals.filter(v => !pairs.includes(v))[0];
			return [3, ...pairs, kicker];
		}
		if (first[1] === 2) return [2, first[0], ...uniqueVals.filter(v => v !== first[0]).slice(0, 3)];
		return [1, ...uniqueVals.slice(0, 5)];
	}

	function evaluateCached(hand) {
		const key = hand.slice().sort().join('');
		if (evalCache.has(key)) return evalCache.get(key);
		const result = evaluate(hand);
		evalCache.set(key, result);
		return result;
	}

	function shuffle(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	}

	function removeCards(deck, cards) {
		for (const card of cards) {
			const idx = deck.indexOf(card);
			if (idx !== -1) deck.splice(idx, 1);
		}
	}

	for (let sim = 0; sim < simulations; sim++) {
		const deck = [...fullDeck];
		removeCards(deck, allCards);
		shuffle(deck);
		const board = deck.slice(0, 5);

		let best = null;
		let winners = [];

		for (let i = 0; i < numPlayers; i++) {
			const fullHand = [...players[i], ...board];
			const score = evaluateCached(fullHand);

			if (!best || compare(score, best) > 0) {
				best = score;
				winners = [i];
			} else if (compare(score, best) === 0) {
				winners.push(i);
			}
		}

		if (winners.length === 1) wins[winners[0]]++;
		else draws++;
	}

	const result = {};
	for (let i = 0; i < numPlayers; i++) {
		result[`Igrac${i}`] = +((wins[i] * 100) / simulations).toFixed(0);
	}
	result.Draws = +((draws * 100) / simulations).toFixed(0);
	return result;

	function compare(a, b) {
		for (let i = 0; i < Math.max(a.length, b.length); i++) {
			if ((a[i] ?? 0) > (b[i] ?? 0)) return 1;
			if ((a[i] ?? 0) < (b[i] ?? 0)) return -1;
		}
		return 0;
	}
}

//// ***********************************************************
export function winRateBoard(data, brojIgraca, igracTableSvi, flop = [], turn = [], river = []) {
	if (igracTableSvi === null) return null;
	var simulations = 8000;
	const players = [];
	for (let i = 0; i < brojIgraca; i++) {
		const igracKey = `igrac${i}`;
		if (igracTableSvi[igracKey] !== null) {
			players.push([data[i], data[i + brojIgraca]]);
		}
	}
	const numPlayers = players.length;
	const allCards = players.flat();
	const rankMap = {
		2: 0,
		3: 1,
		4: 2,
		5: 3,
		6: 4,
		7: 5,
		8: 6,
		9: 7,
		T: 8,
		J: 9,
		Q: 10,
		K: 11,
		A: 12,
	};

	const fullDeck = FullDeck;
	const wins = new Array(numPlayers).fill(0);
	let draws = 0;
	const evalCache = new Map();

	function evaluate(hand) {
		const counts = {};
		const suitsCount = {};
		const values = [];

		for (const card of hand) {
			const r = card[0],
				s = card[1];
			const v = rankMap[r];
			counts[v] = (counts[v] || 0) + 1;
			suitsCount[s] = (suitsCount[s] || 0) + 1;
			values.push(v);
		}

		values.sort((a, b) => b - a);
		const uniqueVals = [...new Set(values)].sort((a, b) => b - a);

		let isFlush = false,
			flushSuit = null;
		for (const s in suitsCount) {
			if (suitsCount[s] >= 5) {
				isFlush = true;
				flushSuit = s;
				break;
			}
		}

		let isStraight = false,
			topStraightValue = -1;
		for (let i = 0; i <= uniqueVals.length - 5; i++) {
			if (uniqueVals[i] - uniqueVals[i + 4] === 4) {
				isStraight = true;
				topStraightValue = uniqueVals[i];
				break;
			}
		}
		if (!isStraight && [12, 0, 1, 2, 3].every(v => uniqueVals.includes(v))) {
			isStraight = true;
			topStraightValue = 3;
		}

		let isStraightFlush = false,
			topStraightFlushValue = -1;
		if (flushSuit) {
			const flushVals = hand.filter(c => c[1] === flushSuit).map(c => rankMap[c[0]]);
			const flushUnique = [...new Set(flushVals)].sort((a, b) => b - a);
			for (let i = 0; i <= flushUnique.length - 5; i++) {
				if (flushUnique[i] - flushUnique[i + 4] === 4) {
					isStraightFlush = true;
					topStraightFlushValue = flushUnique[i];
					break;
				}
			}
			if (!isStraightFlush && [12, 0, 1, 2, 3].every(v => flushUnique.includes(v))) {
				isStraightFlush = true;
				topStraightFlushValue = 3;
			}
		}

		const groups = Object.entries(counts)
			.map(([k, v]) => [parseInt(k), v])
			.sort((a, b) => b[1] - a[1] || b[0] - a[0]);
		const [first, second = [-1, 0]] = groups;

		if (isStraightFlush) return [9, topStraightFlushValue];
		if (first[1] === 4) return [8, first[0], ...uniqueVals.filter(v => v !== first[0])];
		if (first[1] === 3 && second[1] >= 2) return [7, first[0], second[0]];
		if (isFlush) {
			const flushCards = hand
				.filter(c => c[1] === flushSuit)
				.map(c => rankMap[c[0]])
				.sort((a, b) => b - a);
			return [6, ...flushCards.slice(0, 5)];
		}
		if (isStraight) return [5, topStraightValue];
		if (first[1] === 3) return [4, first[0], ...uniqueVals.filter(v => v !== first[0]).slice(0, 2)];
		if (first[1] === 2 && second[1] === 2) {
			const pairs = [first[0], second[0]].sort((a, b) => b - a);
			const kicker = uniqueVals.filter(v => !pairs.includes(v))[0];
			return [3, ...pairs, kicker];
		}
		if (first[1] === 2) return [2, first[0], ...uniqueVals.filter(v => v !== first[0]).slice(0, 3)];
		return [1, ...uniqueVals.slice(0, 5)];
	}

	function evaluateCached(hand) {
		const key = hand.slice().sort().join('');
		if (evalCache.has(key)) return evalCache.get(key);
		const result = evaluate(hand);
		evalCache.set(key, result);
		return result;
	}

	function shuffle(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	}

	function removeCards(deck, cards) {
		for (const card of cards) {
			const idx = deck.indexOf(card);
			if (idx !== -1) deck.splice(idx, 1);
		}
	}

	function compare(a, b) {
		for (let i = 0; i < Math.max(a.length, b.length); i++) {
			if ((a[i] ?? 0) > (b[i] ?? 0)) return 1;
			if ((a[i] ?? 0) < (b[i] ?? 0)) return -1;
		}
		return 0;
	}

	const board = [...flop, ...turn, ...river];
	for (let sim = 0; sim < simulations; sim++) {
		const deck = [...fullDeck];
		removeCards(deck, allCards);
		removeCards(deck, board);
		shuffle(deck);

		const simBoard = [...board];
		while (simBoard.length < 5) {
			simBoard.push(deck.pop());
		}

		let best = null;
		let winners = [];

		for (let i = 0; i < numPlayers; i++) {
			const fullHand = [...players[i], ...simBoard];
			const score = evaluateCached(fullHand);

			if (!best || compare(score, best) > 0) {
				best = score;
				winners = [i];
			} else if (compare(score, best) === 0) {
				winners.push(i);
			}
		}

		if (winners.length === 1) wins[winners[0]]++;
		else draws++;
	}

	const result = {};
	for (let i = 0; i < numPlayers; i++) {
		result[`Igrac${i}`] = Math.round((wins[i] * 100) / simulations);
	}
	result.Draws = Math.round((draws * 100) / simulations);

	const playersDataReturn = {};
	let brojac = 0;
	for (let i = 0; i < brojIgraca; i++) {
		const igracKey = `igrac${i}`;
		if (igracTableSvi[igracKey] !== null) {
			playersDataReturn[`Igrac${i}`] = result[`Igrac${brojac}`];
			brojac++;
		} else {
			playersDataReturn[`Igrac${i}`] = null;
		}
	}
	playersDataReturn.Draws = result.Draws;
	return playersDataReturn;
}
